import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Stars } from 'components/review/Stars';
import { Image } from 'components/core/Image';

import sfRatingBadge from 'assets/images/icons/sf-rating-badge.svg';
import googleIcon from 'assets/images/icons/google.svg';
import './StarReview.scss';

export function StarReviewV2({
	rating,
	reviewCount,
	outOf = 5,
	starSize = 'small',
	className,
	color = 'yellow',
	variant = 'default',
	scrollToReviews = () => {},
	reviewType = 'sparefoot'
}) {

	return (
		<div 
			className={classnames(className, 'sf-star-review', {[`sf-star-review--${variant}`]: variant})}
			onClick={scrollToReviews}
		>

			<div className="sf-star-review-content">
				<Image
					src={reviewType === 'google' ? googleIcon : sfRatingBadge}
					alt="Rating Badge"
					className="rating-badge-icon"
				/>
				<div className="sf-rating-display">
					<Stars
						rating={rating}
						outOf={outOf}
						size={starSize}
						color={color}
					/>
					<span className="sf-rating-number">{rating ? rating.toFixed(1) : 0}</span>
				</div>
				<span className="sf-review-count">
					({reviewCount})
				</span>
			</div>
		</div>
	);
}

StarReviewV2.propTypes = {
	/** The review rating to render stars for */
	rating: PropTypes.number.isRequired,
	/** Number of reviews */
	reviewCount: PropTypes.number.isRequired,
	/** What the review rating is out of */
	outOf: PropTypes.number,
	/** Star size */
	starSize: PropTypes.oneOf(['tiny', 'smaller', 'small', 'medium', 'large']),
	reviewType: PropTypes.oneOf(['google', 'sparefoot']),
	/** Star color */
	color: PropTypes.string,
	className: PropTypes.string,
	/** Visual variant of the component */
	variant: PropTypes.oneOf(['default', 'compact', 'featured']),
	scrollToReviews: PropTypes.func,
};

export default StarReviewV2;
